import $ from 'jquery';
import initRteAccordions from './initRteAccordions';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    initRteAccordions(`[data-section-id="${e.detail.sectionId}"]`);
  });
};